import { memo } from "react";

import { PlainTooltip } from "@similarweb/ui-components";

import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";

import { StyledNotConnectedTag } from "./styles";

const NotConnectedTag = () => {
    return (
        <PlainTooltip
            placement="top"
            tooltipContent={
                <I18n
                    translatable={{
                        key: "si.account-overview.integration-tag.not-connected.tooltip",
                    }}
                />
            }
        >
            <StyledNotConnectedTag>
                <I18n
                    data-automation="integration-text"
                    translatable={{ key: "si.account-overview.integration-tag.not-connected" }}
                />
            </StyledNotConnectedTag>
        </PlainTooltip>
    );
};

export default memo(NotConnectedTag);
